import { ListValueProp } from "@hitachivantara/uikit-react-core";
import { useCallback } from "react";
import { Row } from "react-table";

const useMembersFilters = (): [
  (
    rows: Row<MemberDataRow>[],
    columnIds: string[],
    filterValue: MembersTableFilter,
    selectedMembers?: UserWithGroup[] | undefined
  ) => Row<MemberDataRow>[],
  (
    rows: Row<MemberDataRow>[],
    columnIds: string[],
    filterValue: ListValueProp[]
  ) => Row<MemberDataRow>[]
] => {
  const filterSearch = useCallback(
    (
      rows: Row<MemberDataRow>[],
      columnIds: string[],
      filterValue: string
    ): Row<MemberDataRow>[] =>
      rows.filter(
        (row) =>
          row.original.email.includes(filterValue) ||
          row.original.name.includes(filterValue) ||
          row.original.surname.includes(filterValue)
      ),
    []
  );

  const isSelected = useCallback(
    (data: Row<MemberDataRow>, memb: UserWithGroup[]): boolean =>
      memb.findIndex((mem) => mem.id === data.original.id) !== -1,
    []
  );

  const filterMembers = useCallback(
    (
      rows: Row<MemberDataRow>[],
      selectedMembers?: UserWithGroup[]
    ): Row<MemberDataRow>[] =>
      rows.filter((row) => isSelected(row, selectedMembers || [])),
    [isSelected]
  );

  const globalFilter = useCallback(
    (
      rows: Row<MemberDataRow>[],
      columnIds: string[],
      filterValue: MembersTableFilter,
      selectedMembers?: UserWithGroup[]
    ): Row<MemberDataRow>[] => {
      let result = filterSearch(rows, columnIds, filterValue.searchKey || "");
      if (filterValue.viewOption === "member")
        result = filterMembers(result, selectedMembers);
      return result;
    },
    [filterMembers, filterSearch]
  );

  const filterGroup = useCallback(
    (
      rows: Row<MemberDataRow>[],
      filterValue: ListValueProp
    ): Row<MemberDataRow>[] =>
      rows.filter((row) =>
        row.original.group.includes(filterValue.label?.toString() || "")
      ),
    []
  );

  const filterGroups = useCallback(
    (
      rows: Row<MemberDataRow>[],
      columnIds: string[],
      filterValue: ListValueProp[]
    ): Row<MemberDataRow>[] => {
      const res = filterValue
        .map((filter) => filterGroup(rows, filter))
        .flat()
        .filter(
          (row, idx, arr) => arr.findIndex((r) => r.id === row.id) === idx
        );

      return filterValue.length ? res : rows;
    },
    [filterGroup]
  );
  return [globalFilter, filterGroups];
};

export default useMembersFilters;
